function getHyperLink(url: string) {
  return `<a href="${url}" target="_blank"> Click here </a>`;
}

export function extractLinkInfo(linkString: string) {
  // Use a regular expression to match the link text and URL
  const match = linkString.match(/^(.*?)\s(https?:\/\/\S+)$/);

  if (match && match.length === 3) {
    // match[1] contains the link text, match[2] contains the URL
    const linkText = match[1];
    const url = match[2];

    return { linkText: linkText, url: url };
  } else if (linkString.match(/^https?:\/\/\S+$/)) {
    // If only a link is present
    return { url: linkString };
  } else {
    // If no link is present, return the string
    return { linkText: linkString };
  }
}

export default function convertLinkToHyperLink(msgString: string) {
  const msgInfo = extractLinkInfo(msgString);
  // const keys = Object.keys(msgInfo);
  if ('linkText' in msgInfo && 'url' in msgInfo) {
    const hyperLink = getHyperLink(msgInfo.url as string);
    return `${msgInfo.linkText} ${hyperLink}`;
  } else if ('linkText' in msgInfo) {
    return msgInfo.linkText;
  }
  return msgInfo.url;
}
